/** Dispatched by "Take the tour" on Profile; the tour mounted around the shell listens for it. */
export const START_POS_TOUR_EVENT = 'pos:start-till-tour';

/** The tour is of the sale screen, so the caller goes there first. */
export function startPosTour(): void {
  window.dispatchEvent(new Event(START_POS_TOUR_EVENT));
}
